import React from 'react';
import { useSelector } from 'react-redux';

import PlayPauseIcon from '../icons/PlayPauseIcon';
import FullscreenIcon from '../icons/FullscreenIcon';
import CamIcon from '../icons/CamIcon';

interface Props {
  isPlaying: boolean;
  isFullscreen: boolean | undefined;
  camSetup?: number[];
  togglePlaying: () => void;
  toggleFullscreen: () => void;
}

const CamControls = ({
  isFullscreen,
  isPlaying,
  camSetup = [1, 2, 3, 4, 9],
  togglePlaying,
  toggleFullscreen,
}: Props) => {
  const numCams = useSelector((state: any) => state?.multiCam?.numCams);

  return (
    <div className="sl-multi-cam__controls">
      <div className="sl-multi-cam__controls--left">
        <div className="sl-multi-cam__controls__view">
          {camSetup.map((camNum) => (
            <CamIcon key={camNum} active={camNum === numCams} camNum={camNum} />
          ))}
        </div>
      </div>
      <div className="sl-multi-cam__controls--right">
        <PlayPauseIcon isPlaying={isPlaying} onClick={togglePlaying} />
        <FullscreenIcon isFullscreen={isFullscreen} onClick={toggleFullscreen} />
      </div>
    </div>
  );
};

export default CamControls;
